(function () {

  'use strict';

  angular.module('SnmpConfigurationProperties')

  .constant('SNMP_CONFIGURATION_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
    ])

  .controller('SnmpConfigurationPropertiesController', ['$scope', 'TenantListService', '$http', 'SnmpConfigurationService', '$routeParams',
    'URL_PARAMS', 'SNMP_CONFIGURATION_PROPERTIES_TABS', 'EventServiceEvents', 'toastr', '$rootScope', '$filter', 'URLS', '$location', '$ngBootbox',
    'PrinterListService', 'PrinterListPOSTPaging', 'NetworkListPaging', 'PrinterVendorListPaging', 'PrinterVendorService', 'NetworkListService',
    function ($scope, TenantListService, $http, SnmpConfigurationService, $routeParams, URL_PARAMS, SNMP_CONFIGURATION_PROPERTIES_TABS,
      EventServiceEvents, toastr, $rootScope, $filter, URLS, $location, $ngBootbox, PrinterListService, PrinterListPOSTPaging, NetworkListPaging,
      PrinterVendorListPaging, PrinterVendorService, NetworkListService) {

      $scope.me = $rootScope.currentUser;
      $scope.tabs = SNMP_CONFIGURATION_PROPERTIES_TABS;
      $scope.snmpConfigurationOriginal = null;
      $scope.snmpConfiguration = null;
      $scope.showSnmpToolbox = false;
      $scope.tenantLoaded = false;
      $scope.snmpConfigLoaded = false;
      $scope.printersLoaded = false;
      $scope.helpCaption = 'HelpSnmpConfigurationPage';

      $scope.updatingSnmpConfig = false;
      $scope.authenticationLevel = null;
      $scope.authentication = null;
      $scope.privacy = null;

      $scope.selectedNetworks = [];

      $scope.searchInputPlaceholderText = 'Search';
      $scope.printerListPaging = new PrinterListPOSTPaging();
      $scope.printerListForMassDistributionPaging = new PrinterListPOSTPaging();
      $scope.networkListPaging = new NetworkListPaging();
      $scope.printerVendorListPaging = new PrinterVendorListPaging();
      $scope.tenant = null;

      $scope.setSection = function(section) {
        $scope.showSection = section;

        var url = $location.path();
        $location.path(url, false).search({ snmpConfigurationSection: section });
      };

      (function() {
        if ($routeParams['snmpConfigurationSection']) {
          $scope.showSection = $routeParams['snmpConfigurationSection'];
        } else {
          $scope.showSection = 'setup';
        }
      })();

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      $scope.$watch(function() {
        return TenantListService
      }, function() {
        if (TenantListService.currentTenant) {
          $scope.tenant = TenantListService.currentTenant;
          $scope.tenantLoaded = true;
          $scope.getPrinters();
          getSnmpConfig();
        }
      }, true);



      function getSnmpConfig() {
        const snmpId = $routeParams[URL_PARAMS.SNMP_CONFIG_URL.ROUTE]
        const url = $scope.tenant.info._links['px:printers'].href + "/snmp/" + snmpId;
        SnmpConfigurationService.getSnmpConfigurationByUrl(url).then(function (snmpConfiguration) {
          $scope.snmpConfiguration = angular.copy(snmpConfiguration);
          $scope.snmpConfigurationOriginal = angular.copy(snmpConfiguration);
          $scope.snmpConfigLoaded = true;
          $scope.getPrinters();
          $scope.getSelectedNetworks();
          setSelectedItem();
        }).catch(function(error){});
      }

      $scope.getPrinters = function () {
        if ($scope.tenantLoaded && $scope.snmpConfigLoaded) {
          $scope.printerListPaging.pagingCriteria.includeSnmpConfigurations = [$scope.snmpConfiguration.info._links.self.href];
          PrinterListService.getPrinterListPaged($scope.printerListPaging).then(function (response) {
            $scope.printerContainer = response;
            $scope.printersLoaded = true;
          }).catch(function(error){});
        }
      }

      $scope.getSelectedNetworks = function () {
        $scope.selectedNetworks = [];
        if ($scope.snmpConfiguration.info.networkIds?.length) {
          NetworkListService.getNetworksByIds($scope.snmpConfiguration.info.networkIds).then(function (response) {
            $scope.selectedNetworks = response.data.map(network => {
              return { id: network.networkId, name: network.name };
            }).sort((a, b) => a.name.localeCompare(b.name));
          }).catch(function(error){
            console.error(`NetworkListService.getNetworksByIds() failed with error code ${response.status}.`);
          });
        }
      };

      $scope.getNamesOfSelectedNetworks = function () {
        return $scope.selectedNetworks.map(sn => sn.name);
      };

      $scope.getPreviousPageOfPrinters = function functionName() {
        if ($scope.printerListPaging.pagingCriteria.page > 0) {
          $scope.printerListPaging.pagingCriteria.page--;
          $scope.getPrinters();
        }
      }

      $scope.getNextPageOfPrinters = function functionName() {
        if ($scope.printerListPaging.pagingCriteria.page + 1 < $scope.printerContainer.page.totalPages) {
          $scope.printerListPaging.pagingCriteria.page++;
          $scope.getPrinters();
        }
      }

      $scope.getNetworkName = function(printer) {
        if (printer.info._links['px:network']) {
          var network = $scope.printerContainer.networks.findElement({_links: {self: {href: printer.info._links['px:network'].href}}});
          if (network) {
            return network.name;
          } else {
            return $filter("translate")("UnknownNetwork");
          }
        } else {
          return "";
        }
      };

      $scope.editSelectedPrinters = function(printer) {
        var url = URLS.PRINTER_PROPERTIES.replace(URL_PARAMS.PRINTER_URL.LOCATION, printer.customProperties.id);
        $location.path(url);
      }

      $scope.openToolbox = function() {
        $scope.showSnmpToolbox = !$scope.showSnmpToolbox;
        $scope.clearPopups();
      }

      function setSelectedItem () {
        $scope.authenticationLevel = {
          listRaw: [{ name: 'NOAUTHNOPRIV', id: 'NOAUTHNOPRIV' }, { name: 'AUTHNOPRIV', id: 'AUTHNOPRIV' }, { name: 'AUTHPRIV', id: 'AUTHPRIV' }],
          placeholderText: 'Select',
          skipOrderByName: true
        };
        $scope.authenticationLevel.selectedItem = getCurrentSelectedItem('authenticationLevel')

        $scope.authentication = {
          listRaw: [{ name: 'SHA', id: 'SHA' }, { name: 'MD5', id: 'MD5' }],
          placeholderText: 'Select',
          skipOrderByName: true
        }
        $scope.authentication.selectedItem = getCurrentSelectedItem('authentication')

        $scope.privacy = {
          listRaw: [{ name: 'DES', id: 'DES' }, { name: 'AES', id: 'AES' }],
          placeholderText: 'Select',
          skipOrderByName: true
        }
        $scope.privacy.selectedItem = getCurrentSelectedItem('privacy')
      }

      function getCurrentSelectedItem(context) {
        for (var i = 0; i <  $scope[context].listRaw.length; i++) {
          if ($scope[context].listRaw[i].id === $scope.snmpConfiguration.info[context]) {
            return $scope[context].listRaw[i];
          }
        }
        return null;
      }

      $scope.updateSnmpConfig = function (snmpConfig) {
        $scope.updatingSnmpConfig = true;

        snmpConfig = cleanUpSnmpConfigBeforeUpdate(snmpConfig);

        $scope.snmpConfiguration.saveChanges(snmpConfig).then(function(response) {
          $scope.updatingSnmpConfig = false;
          toastr.success($filter("translate")("ChangesSaved"));
        }).catch(function(error){
          $scope.updatingSnmpConfig = false;
          if (error) {
            toastr.error($filter("translate")("NoChangesMade"));
          } else {
            toastr.warning($filter("translate")("NoChangesMade"));
          }
        });
      }

      function cleanUpSnmpConfigBeforeUpdate (snmpConfig) {
        if (snmpConfig.info.version === 'V1') {
          snmpConfig.info.contextName = null;
          snmpConfig.info.authenticationLevel = null;
          snmpConfig.info.user = null;
          snmpConfig.info.authentication = null;
          snmpConfig.info.authPhrase = null;
          snmpConfig.info.privacy = null;
          snmpConfig.info.privacyPhrase = null;
        }
        if (snmpConfig.info.version === 'V3') {
          if ($scope.snmpConfiguration.info.communityName) {
            snmpConfig.info.communityName = null;
          }

          if (snmpConfig.info.authenticationLevel === 'NOAUTHNOPRIV') {
            snmpConfig.info.authentication = null;
            snmpConfig.info.authPhrase = null;
            snmpConfig.info.privacy = null;
            snmpConfig.info.privacyPhrase = null;
          }

          if (snmpConfig.info.authenticationLevel === 'AUTHNOPRIV') {
            snmpConfig.info.privacy = null;
            snmpConfig.info.privacyPhrase = null;
          }
        }

        return snmpConfig;
      }

      $scope.validateSnmpV3Form = function () {
        var snmpV3FormInvalid = false;
        if (!$scope.snmpConfiguration.info.name) {
          snmpV3FormInvalid = true;
        }
        if (!$scope.snmpConfiguration.info.user) {
          snmpV3FormInvalid = true;
        }
        if (!$scope.snmpConfiguration.info.contextName) {
          snmpV3FormInvalid = true;
        }

        if (!$scope.snmpConfiguration.info.authenticationLevel && $scope.snmpConfiguration.info.authenticationLevel !== 'NOAUTHNOPRIV') {
          snmpV3FormInvalid = true;
        } else if ($scope.snmpConfiguration.info.authenticationLevel === 'AUTHNOPRIV') {
          if (!$scope.snmpConfiguration.info.authentication ||  !$scope.snmpConfiguration.info.authPhrase) {
            snmpV3FormInvalid = true;
          }
        } else if ($scope.snmpConfiguration.info.authenticationLevel === 'AUTHPRIV') {
          if (!$scope.snmpConfiguration.info.authentication ||  !$scope.snmpConfiguration.info.authPhrase || !$scope.snmpConfiguration.info.privacy ||  !$scope.snmpConfiguration.info.privacyPhrase) {
            snmpV3FormInvalid = true;
          }
        }
        return snmpV3FormInvalid;
      }

      $scope.selectSnmpSecurytLevelType = function(item) {
        $scope.snmpConfiguration.info.authenticationLevel = item.id;
      }

      $scope.selectAuthenticationType = function(item) {
        $scope.snmpConfiguration.info.authentication = item.id;
      }

      $scope.selectPrivacyType = function(item) {
        $scope.snmpConfiguration.info.privacy = item.id;
      }

      $scope.resetSnmpForm = function () {
        $scope.snmpConfiguration = angular.copy($scope.snmpConfigurationOriginal);
      }

      $scope.deleteSnmpConfig = function () {
        $scope.showSnmpToolbox = false;
        $scope.snmpConfiguration.deleteSnmpConfig($scope.snmpConfiguration).then(function() {
          toastr.success($filter("stringular")($filter("translate")("SnmpConfigurationDeleted"), $scope.snmpConfiguration.info.name));
        }).catch(function(error){
          toastr.error(($filter("translate")("Error")))
        });
      }

      $scope.modifySnmpConfig = function(event) {
        event.stopPropagation();
        $scope.clearPopups();

        $scope.snmpFormData = {
          snmpConfiguration: angular.copy($scope.snmpConfiguration),
          snmpConfigurationOriginal: $scope.snmpConfigurationOriginal,
          selectedNetworks: angular.copy($scope.selectedNetworks)
        };

        $scope.modifySnmpConfigPopupObject = {
          dimensions: { width: 600 },
          offset: { top: -100, left: 20 },
          pointerPosition: 'middle',
          relativePosition: 'right',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          type: 'SNMP_FORMS',
          title: 'SnmpConfiguration',
          confirmText: 'Save',
          cancelText: 'Cancel',
          clickOutsideToClose: false
        }
      }

      $scope.assignSnmpConfigToPrinters = function (event) {
        $scope.networkListPaging.pagingCriteria.pageSize = 4;
        $scope.printerVendorListPaging.pagingCriteria.pageSize = 4;
        event.stopPropagation();
        $scope.clearPopups();
        $scope.massDistributeSnmpData = {
          paginationObjects: [{
            name: 'Networks',
            icon: null,
            pagination: {
              context: 'Networks',
              paginationObject: $scope.networkListPaging,
              placeholderText: 'Search',
              service: 'NetworkListService',
              multiSelect: true,
              contextObject: angular.copy($rootScope.currentUser),
            },
            popup: {
              pointerDirection: 'up',
              pointerPosition: 'right',
              dimensions: { height: 360, width: 300 },
              relativePosition: 'under',
              offset: { top: 0, left: 52},
              type: 'PAGINATION',
              title: 'Networks',
              confirmText: 'Filter',
              clickOutsideToClose: false,
            }
          },
          {
            name: 'Vendors',
            icon: null,
            pagination: {
              context: 'Vendors',
              paginationObject: $scope.printerVendorListPaging,
              placeholderText: 'Search',
              service: 'PrinterVendorService',
              multiSelect: true,
              contextObject: angular.copy($rootScope.currentUser),
            },
            popup: {
              pointerDirection: 'up',
              pointerPosition: 'right',
              dimensions: { height: 360, width: 300 },
              relativePosition: 'under',
              offset: { top: 0, left: 52},
              type: 'PAGINATION',
              title: 'Vendors',
              confirmText: 'Filter',
              clickOutsideToClose: false,
            }
          }],
          massDistributionObject: {
            service: 'PrinterListService',
            paginationObject: $scope.printerListForMassDistributionPaging,
          },
          checkboxData: {
            label: 'Confirm',
            value: false,
            required: true
          }
        };

        var offsetLeft = event.currentTarget.clientWidth - 10;
        $scope.massDistributeSnmpConfigPopupObject = {
          dimensions: {height: 404, width: 600},
          offset: {top: 11, left: offsetLeft},
          pointerDirection: 'left',
          pointerPosition: 'bottom',
          relativePosition: 'right',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          type: 'MASS_DISTRIBUTION',
          title: 'DistributeSnmpConfiguration',
          confirmText: 'Distribute',
          clickOutsideToClose: false
        }
      };

      $scope.openDeleteSnmpConfigDialog = function (event) {
        event.stopPropagation();
        $scope.clearPopups();

        $scope.deleteSnmpConfirmDialog= {
          confirm: 'Delete',
          warning: null,
          danger: true,
          cancel: 'Cancel',
          validationString: null,
          context: {
            type: 'Printers',
            count: $scope.printerContainer.page.totalElements
          }
        };

        var offsetLeft = event.currentTarget.clientWidth - 10;
        $scope.deleteSnmpConfigPopupObject = {
          dimensions: {height: 200, width: 300},
          offset: {top: 11, left: offsetLeft},
          pointerDirection: 'left',
          pointerPosition: 'bottom',
          relativePosition: 'right',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          type: 'CONFIRM',
          title: 'DeleteSnmpConfiguration',
          confirmText: null,
          clickOutsideToClose: true
        }
      }

      $scope.clearPopups = function () {
        $scope.snmpFormData = null;
        $scope.modifySnmpConfigPopupObject = null;

        $scope.massDistributeSnmpConfigPopupObject = null;
        $scope.massDistributeSnmpData = null;

        $scope.deleteSnmpConfigPopupObject = null;
        $scope.deleteSnmpConfirmDialog = null;
      };

      $scope.executeMassDistribution = function(filters) {
        $scope.snmpConfiguration.massDistributeSnmpConfigurationToPrinters(filters).then(function(response) {
          toastr.success($filter("translate")("ChangesSaved"));
        }).catch(function(error){
          toastr.success($filter("translate")("ERROR"));
        });
      };

      $scope.canUserDeleteSnmpConfiguration = function (snmpConfiguration) {
        return !snmpConfiguration.info.tenantDefault &&
          ($scope.me.permissions.TENANT_ADMIN || snmpConfiguration.info.networkIds.length) &&
          $scope.printersLoaded && !$scope.printerContainer.list.length;
      };

      var SNMP_CONFIGURATION_UPDATED_listener =$rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SNMP_CONFIGURATION_UPDATED, function (name, data) {
        if (data.config === $scope.snmpConfiguration.info._links.self.href) {
          getSnmpConfig();
        }
      });

      var SNMP_CONFIGURATION_DELETED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SNMP_CONFIGURATION_DELETED, function (name, data) {
        if (data.config === $scope.snmpConfiguration.info._links.self.href) {
          var url = URLS.SETTINGS;
          $location.path(url)
          $location.search(URL_PARAMS.SHOW_SETTINGS_SECTION.ROUTE, 'snmp');
        }
      });

      $scope.$on('$destroy', function () {
        SNMP_CONFIGURATION_UPDATED_listener();
        SNMP_CONFIGURATION_DELETED_listener();
      });

  }]);

})();
